module.exports = __webpack_public_path__ + "static/img/customer5.ea848f8d.png";